export enum AsyncTaskType {
  MEMBER_ROSTER = 'MEMBER_ROSTER',
  CARE_TEAM_ROSTER = 'CARE_TEAM_ROSTER',
  CANDIDATE_ROSTER = 'CANDIDATE_ROSTER',
  POD_SHUFFLE_ROSTER = 'POD_SHUFFLE_ROSTER',
}
